import * as React from "react";
import {ComponentSpinner} from "./ComponentSpinner";

export class ProgressButton extends React.Component<{ className: string, inProgress: boolean, onClick: () => void }, {}> {
    render() {

        if (this.props.inProgress == true) {
            return <a className={this.props.className}><ComponentSpinner/></a>
        }
        return (
            <a onClick={this.props.onClick} className={this.props.className}>{this.props.children}</a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/util/ProgressButton.tsx